import { useState, useEffect } from "react";
import { getLatestNewsFeaturedWidget } from "../api/widgets/latestNewsFeatured/requests";

function useStoryblokLatestNewsFeaturedWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getLatestNewsFeaturedWidget()
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokLatestNewsFeaturedWidget };
